import React, { useState, useEffect } from "react";
import Table, { TableRow, TableCell } from "@amzn/meridian/table";
import Pagination from "@amzn/meridian/pagination";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import { fetchData } from "../../commons/api/PriorityPackagesAPI.js";

const PriorityPackages = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [packageData, setPackageData] = useState([]);
  useEffect(() => {
    var packages = fetchData(1);
    setPackageData(packages);
  }, []);
  const renderPackages = (packages, index) => {
    return (
      <TableRow highlightOnHover={true}>
        <TableCell>{packages.trackingId}</TableCell>
        <TableCell>{packages.reason}</TableCell>
        <TableCell>{packages.act}</TableCell>
        <TableCell>{packages.promisedDate}</TableCell>
        <TableCell>{packages.pastFail}</TableCell>
        <TableCell>{packages.remarks}</TableCell>
      </TableRow>
    );
  };
  return (
    <div className="PriorityPackages">
      <Row widths="fill" spacingInset="large large none large">
        <Text type="h400">Priority packages</Text>
      </Row>
      <Row widths={["grid-12"]} spacingInset="large large large large">
        <Table headerRows={1} showStripes={true} showDividers={true}>
          <TableRow highlightOnHover={true}>
            <TableCell>Tracking ID</TableCell>
            <TableCell>Reason</TableCell>
            <TableCell>Action to be taken</TableCell>
            <TableCell>Promised Date</TableCell>
            <TableCell>Numbers of past failures</TableCell>
            <TableCell>Remarks</TableCell>
          </TableRow>
          {packageData
            .slice((currentPage - 1) * 30, currentPage * 30)
            .map(renderPackages)}
        </Table>
      </Row>
      <Row
        widths={["grid-7"]}
        spacingInset="large"
        alignmentHorizontal="center"
      >
        <Pagination
          numberOfPages={Math.ceil(packageData.length / 30)}
          onChange={setCurrentPage}
          currentPage={currentPage}
        />
      </Row>
    </div>
  );
};

export default PriorityPackages;



// WEBPACK FOOTER //
// ./src/components/priority/PriorityPackages.js